import React from 'react';

import styled from 'styled-components';

import { APIEntityType } from '@cd3p/core/types/api';
import { SENSITIVE_FIELD_PLACEHOLDER } from '@cd3p/core/utils/sensitiveData';
import { Stack, Tooltip, Typography } from 'components';

import { RouterLink } from 'third-party';

import { TOOLTIP_APPEAR_DELAY } from 'constants/common';

import { SensitiveData } from 'features/SensitiveData/SensitiveData';

const Inner = styled(Stack)`
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
`;

const StyledReadOnlyField = styled(Stack)`
  margin-bottom: 1.2rem;
  font-size: 1.6rem;
  line-height: 2rem;
`;

const StyledValueLink = styled(RouterLink)`
  color: ${props => props.theme.custom.palette.gray};
  text-decoration: none;
  line-height: 1.25;
  &:hover {
    color: ${props => props.theme.custom.palette.info600};
    text-decoration: underline;
  }
`;

interface Props {
  showTooltip?: boolean;
  isSensitive?: boolean;
  sensitiveEntityId?: string | number;
  sensitiveEntityType?: APIEntityType;
  label?: string;
  value?: string | number | React.ReactElement | null | React.ReactElement[];
  linkTo?: string;
  className?: string;
  linkState?: any;
  children?: React.ReactElement | React.ReactElement[] | null;
}

export const ReadOnlyField: React.FC<Props> = ({
  showTooltip = true,
  isSensitive = false,
  sensitiveEntityId,
  sensitiveEntityType,
  value,
  label,
  linkTo,
  className,
  linkState = null,
  children = null,
}) => {
  return (
    <StyledReadOnlyField className={className} key={label} color="#5C6C80">
      <Inner>
        {label && (
          <Typography variant="subtitle2" display="inline">
            {label}:&nbsp;&nbsp;
          </Typography>
        )}
        <Tooltip
          placement="top-start"
          enterDelay={TOOLTIP_APPEAR_DELAY}
          enterNextDelay={TOOLTIP_APPEAR_DELAY}
          title={
            showTooltip
              ? isSensitive
                ? SENSITIVE_FIELD_PLACEHOLDER
                : value
              : ''
          }
        >
          {isSensitive ? (
            <SensitiveData
              entityId={sensitiveEntityId}
              entityType={sensitiveEntityType}
            />
          ) : (
            <span>
              {linkTo ? (
                <StyledValueLink to={linkTo} state={linkState}>
                  {value}
                </StyledValueLink>
              ) : (
                value
              )}
            </span>
          )}
        </Tooltip>
      </Inner>
      {children}
    </StyledReadOnlyField>
  );
};
